import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productStatus'
})
export class ProductStatusPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value === 0) return 'Not Commercially Ready';
    if(value === 1) return 'Commercially Ready';
    if(value === 2) return 'Product is Development';
  }

}
